import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { integrationsService } from '../services/integrations.service';

export function useIntegrations() {
  return useQuery({
    queryKey: ['integrations'],
    queryFn: () => integrationsService.list(),
  });
}

export function useIntegration(id: number) {
  return useQuery({
    queryKey: ['integrations', id],
    queryFn: () => integrationsService.getById(id),
    enabled: !!id,
  });
}

export function useIntegrationLogs(id: number, page: number = 1) {
  return useQuery({
    queryKey: ['integrations', id, 'logs', page],
    queryFn: () => integrationsService.getLogs(id, page),
    enabled: !!id,
  });
}

export function useCreateIntegration() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => integrationsService.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['integrations'] }),
  });
}

export function useUpdateIntegration() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: any }) => integrationsService.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['integrations'] }),
  });
}

export function useDeleteIntegration() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => integrationsService.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['integrations'] }),
  });
}

export function useSyncIntegration() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => integrationsService.sync(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['integrations'] }),
  });
}

export function useTestConnection() {
  return useMutation({
    mutationFn: ({ type, config }: { type: string; config: Record<string, any> }) =>
      integrationsService.testConnection(type, config),
  });
}
